// extracted by mini-css-extract-plugin
export default {"special-workout":"SpecialWorkout_special-workout__qHoPO","special-workout__set-wrapper":"SpecialWorkout_special-workout__set-wrapper__KQe5s"};